<div class="col formscreen">
  <rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
  <form class="loginform" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="col headline">
      <h1>IDS-Administration</h1>
      <span>Login into your <strong>admin</strong> account</span>
    </div>
    <rr-input
      label="Email"
      type="email"
      [required]="true"
      formControlName="email"
    ></rr-input>
    <div class="col withlink tiny">
      <rr-input
        label="Password"
        type="password"
        [required]="true"
        formControlName="password"
      ></rr-input>
      <a href="/login/resetpassword">Forgot password?</a>
    </div>
    <rr-btn type="Primary" (btnClick)="onSubmit()">Log in</rr-btn>
    <rr-divider></rr-divider>
    <span class="tiny"
      >By logging in you agree to our
      <a target="_blank" href="/terms">terms</a> and have read the
      <a target="_blank" href="/privacy">privacy policy</a>.</span
    >
  </form>
</div>
<div class="rightsideimage"></div>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
